import createIcon from '../../createIcon';

/**
 * @component @name ArtTrack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTNIMTRWMTFIMjJWMTNaTTIyIDdIMTRWOUgyMlY3Wk0xNCAxN0gyMlYxNUgxNFYxN1pNMTIgOVYxNUMxMiAxNi4xIDExLjEgMTcgMTAgMTdINEMyLjkgMTcgMiAxNi4xIDIgMTVWOUMyIDcuOSAyLjkgNyA0IDdIMTBDMTEuMSA3IDEyIDcuOSAxMiA5Wk0xMC41IDE1TDguMjUgMTJMNi41IDE0LjI2TDUuMjUgMTIuNzVMMy41IDE1SDEwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArtTrack = createIcon('ArtTrack', [
  [
    'path',
    {
      d: 'M22 13H14V11H22V13ZM22 7H14V9H22V7ZM14 17H22V15H14V17ZM12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9ZM10.5 15L8.25 12L6.5 14.26L5.25 12.75L3.5 15H10.5Z',
      key: 'oh2n07',
    },
  ],
]);

export default ArtTrack;
